import { Pipe, PipeTransform } from '@angular/core';
import { IDateRangeSalesHistoryItem } from '../../pages/articles/core/interfaces/IDateRangeSalesHistoryItem';
import { IDateRangeSalesHistoryStoreItem } from '../../pages/articles/core/interfaces/IDateRangeSalesHistoryStoreItem';

@Pipe({
    name: 'dateRangeSalesHistoryStoreItem',
    standalone: false
})
export class DateRangeSalesHistoryStoreItemPipe implements PipeTransform {

  public transform(item: IDateRangeSalesHistoryItem, storeId: number): IDateRangeSalesHistoryStoreItem {
    return item.stores.find(s => s.storeId === storeId);
  }
}

